module.exports = __webpack_public_path__ + "5a98e23917dd6dc685a3bc266e700525.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg65.jpeg
// module id = 78
// module chunks = 0